module.exports = __webpack_public_path__ + "img/kan@3x.6d6c4331.png";